import { SET_CLIENT, SET_LAUNCHER, SET_UI } from './constants'

const initialState = {
    clientVersion: -1,
    launcherVersion: -1,
    uiVersion: '-1',
}

// sample state:
// const initialState = {
//    uiVersion: '-1',
//    clientVersion: -1,
//    launcherVersion: -1,
// }

const getNumber = (input, defaultValue) => {
    try {
        return parseInt(input, 10)
    } catch (error) {
        if (defaultValue != null) return defaultValue
        return -1
    }
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        // Update the EVE client version
        case SET_CLIENT:
            return { ...state, clientVersion: getNumber(action.payload) }

        // Update the backend launcher version
        case SET_LAUNCHER:
            return { ...state, launcherVersion: getNumber(action.payload) }

        // Update the launcher ui version
        case SET_UI:
            return { ...state, uiVersion: action.payload }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/LoadingBar/data/versions/reducers.js